import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { withTranslation } from "react-i18next";
import { routes } from "../../appRoutingHelpers";
import { OrganizationKeyName } from "../../model/Organization";
import * as partnershipSelectors from "./partnershipSelectors";
import * as partnershipActions from "./partnershipActions";
import { RootState } from "../../store";
import Spinner from "../common/Spinner";
import * as authSelectors from "../auth/authSelectors";
import * as routeHelpers from "../../appRoutingHelpers";
import { Partnership } from "../../service/api-response/PartnershipListSuccessResponse";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { Table } from "../../components/table-components/Table";
import { TableRowHeader } from "../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../components/table-components/TableCellHeaderText";
import { PartnershipListRow } from "./PartnershipListRow";
import { ButtonInternalLink } from "../../components/NewButtons";

interface Props {
  isLoadingPartnerships: boolean;
  partnerships: Partnership[];
  getPartnerships: (org: OrganizationKeyName) => void;
  organization: OrganizationKeyName;
}

interface State {}

const mapStateToProps = (state: RootState, ownProps: {}) => {
  const org = authSelectors.selectedOrganizationKeyName(state);
  return {
    organization: org,
    partnerships: partnershipSelectors.partnershipList(state, org),
    isLoadingPartnerships: partnershipSelectors.isLoadingPartnershipList(
      state,
      org
    ),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getPartnerships: (org: OrganizationKeyName) =>
      dispatch(partnershipActions.listAction(org)),
  };
};

class PartnershipList extends React.Component<Props, State> {
  loadData() {
    this.props.getPartnerships(this.props.organization);
  }

  componentDidMount() {
    this.loadData();
  }

  render() {
    return (
      <div className="container mt-7">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header border-bottom-0 mt-4 mb-4 justify-content-between">
                <StyledText
                  color={colors.textPrimary}
                  className="bodyHeaderOneSemi card-title"
                >
                  Partnerships List
                </StyledText>
                <ButtonInternalLink
                  to={routeHelpers.routes.partnershipAdd(
                    this.props.organization
                  )}
                >
                  Add new
                </ButtonInternalLink>
              </div>
              <div className="pl-5 pr-5">
                <Table>
                  <thead>
                    <TableRowHeader>
                      <TableCellHeaderText className="pl-3">
                        Pool
                      </TableCellHeaderText>
                      <TableCellHeaderText>
                        Member card type
                      </TableCellHeaderText>
                    </TableRowHeader>
                  </thead>
                  <tbody>
                    {this.props.partnerships.map((p) => (
                      <PartnershipListRow
                        href={routes.partnershipEdit(
                          this.props.organization,
                          p.id
                        )}
                        partnership={p}
                        key={p.id}
                      />
                    ))}
                  </tbody>
                </Table>
              </div>
              <div className="card-footer text-center mr-5 ml-5">
                {this.props.isLoadingPartnerships && <Spinner />}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(PartnershipList));
